import { useEffect, useRef } from "react"; /**
 * Get access to the previous value of the input value.
 * @param value
 * @return previous previous state of the value
 */
export function usePreviousStateHook(value) { var ref = useRef(); useEffect(function () { ref.current = value; }, [value]); return ref.current; }
